module.exports = __webpack_public_path__ + "img/axawin.bb51fdb1.jpg";